import { useEffect, useState } from "react";
import LeaguesPage from "../../features/leagues/public/pages/LeaguesPage";
import LeagueDetailsPage from "../../features/leagues/public/pages/LeagueDetailsPage";
import LeagueEditorPage from "../../features/leagues/organizer/pages/LeagueEditorPage";
import LeagueParticipantsPage from "../../features/leagues/organizer/pages/LeagueParticipantsPage";
import AboutPage from "../../features/about/public/pages/AboutPage";
import AdminChallengePage from "../../features/admin/pages/AdminChallengePage";
import AdminCreateChallengePage from "../../features/admin/pages/AdminCreateChallengePage";
import AdminPage from "../../features/admin/pages/AdminPage";
import LoginPage from "../../features/auth/public/pages/LoginPage";
import RegisterPage from "../../features/auth/public/pages/RegisterPage";
import ConfirmEmailPage from "../../features/auth/public/pages/ConfirmEmailPage";
import ResetPasswordPage from "../../features/auth/public/pages/ResetPasswordPage";
import ChallengesHubPage from "../../features/challenges/pages/ChallengesHubPage";
import ChallengesOrganizersPage from "../../features/challenges/pages/ChallengesOrganizersPage";
import ChallengesPage from "../../features/challenges/pages/ChallengesPage";
import ChallengeDetailPage from "../../features/challenges/pages/ChallengeDetailPage";
import TournamentsHubPage from "../../features/challenges/pages/TournamentsHubPage";
import PocoPage from "../../features/challenges/pages/PocoPage";
import SuperEightPage from "../../features/challenges/pages/SuperEightPage";
import SuperTwelvePage from "../../features/challenges/pages/SuperTwelvePage";
import HomePage from "../../features/home/public/pages/HomePage";
import PrivacyPolicyPage from "../../features/legal/public/pages/PrivacyPolicyPage";
import TermsOfUsePage from "../../features/legal/public/pages/TermsOfUsePage";
import EventDetailsPage from "../../features/events/public/pages/EventDetailsPage";
import EventRegistrationPage from "../../features/events/public/pages/EventRegistrationPage";
import PaymentSuccessPage from "../../features/events/public/pages/PaymentSuccessPage";
import MatchDetailPage from "../../features/matches/public/pages/MatchDetailPage";
import MatchesPage from "../../features/matches/public/pages/MatchesPage";
import ClubDetailPage from "../../features/clubs/public/pages/ClubDetailPage";
import ClubsPage from "../../features/clubs/public/pages/ClubsPage";
import AthletesPage from "../../features/players/public/pages/AthletesPage";
import PublicPlayerProfilePage from "../../features/players/public/pages/PublicPlayerProfilePage";
import UserProfilePage from "../../features/profile/public/pages/UserProfilePage";
import RankingHubPage from "../../features/ranking/public/pages/RankingHubPage";
import RankingPage from "../../features/ranking/public/pages/RankingPage";
import ProductDetailPage from "../../features/shop/public/pages/ProductDetailPage";
import ShopPage from "../../features/shop/public/pages/ShopPage";
import {
  getHashRouteFromSharePath,
  getRouteFromHash,
} from "../../shared/lib/router";
import { AppRoute } from "../../shared/types/routes";

function resolvePage(route: AppRoute) {
  if (route.name === "leagues") return <LeaguesPage />;
  if (route.name === "leagueDetail" && route.leagueId) return <LeagueDetailsPage leagueId={route.leagueId} />;
  if (route.name === "organizerLeagues") return <AdminPage leaguesRouteMode />;
  if (route.name === "leagueEditor") return <LeagueEditorPage leagueId={route.leagueId} />;
  if (route.name === "leagueParticipants" && route.leagueId) return <LeagueParticipantsPage leagueId={route.leagueId} />;
  if (route.name === "about") return <AboutPage />;
  if (route.name === "challengesHub") return <ChallengesHubPage />;
  if (route.name === "challengesOrganizersDirectory") {
    return <ChallengesOrganizersPage />;
  }
  if (route.name === "challengesOfficial") {
    return <ChallengesPage forcedOfficialFilter="official" />;
  }
  if (route.name === "challengesOrganizer") {
    return (
      <ChallengesPage
        forcedOfficialFilter="organizer"
        forcedOrganizerUserId={route.organizerUserId}
      />
    );
  }
  if (route.name === "challenges") return <ChallengesPage />;
  if (route.name === "tournaments") {
    return <TournamentsHubPage />;
  }
  if (route.name === "tournamentsOfficial") {
    return (
      <ChallengesPage
        forcedOfficialFilter="official"
        forcedTypeFilter="tournament"
        routeBasePath="torneios"
      />
    );
  }
  if (route.name === "tournamentsOrganizers") {
    return <TournamentsHubPage />;
  }
  if (route.name === "tournamentsOrganizer") {
    return (
      <ChallengesPage
        forcedOfficialFilter="organizer"
        forcedOrganizerUserId={route.organizerUserId}
        forcedTypeFilter="tournament"
        routeBasePath="torneios"
      />
    );
  }
  if (route.name === "challengeDetail" && route.challengeId) {
    return (
      <ChallengeDetailPage
        challengeId={route.challengeId}
        challengeViewGroup={route.challengeViewGroup}
      />
    );
  }
  if (route.name === "tournamentDetail" && route.challengeId) {
    return (
      <ChallengeDetailPage
        challengeId={route.challengeId}
        challengeViewGroup={route.challengeViewGroup}
        origin="tournaments"
      />
    );
  }
  if (route.name === "challengeSuperEight") return <SuperEightPage />;
  if (route.name === "challengeSuperTwelve") return <SuperTwelvePage />;
  if (route.name === "challengePoco") return <PocoPage />;
  if (route.name === "rankingHub") return <RankingHubPage />;
  if (route.name === "rankingOrganizersDirectory") {
    return <RankingHubPage />;
  }
  if (route.name === "rankingOfficial") {
    return <RankingPage forcedSource="official" />;
  }
  if (route.name === "rankingOrganizer") {
    return (
      <RankingPage
        forcedSource="organizer"
        forcedOrganizerUserId={route.organizerUserId}
      />
    );
  }
  if (route.name === "ranking") return <RankingPage />;
  if (route.name === "athletes") return <AthletesPage />;
  if (route.name === "matches") return <MatchesPage />;
  if (route.name === "matchDetail" && route.matchId) {
    return <MatchDetailPage matchId={route.matchId} />;
  }
  if (route.name === "clubs") return <ClubsPage />;
  if (route.name === "clubDetail" && route.clubSlug) {
    return <ClubDetailPage slug={route.clubSlug} />;
  }
  if (route.name === "publicPlayerProfile" && route.playerId) {
    return <PublicPlayerProfilePage playerId={route.playerId} />;
  }
  if (route.name === "shop") return <ShopPage />;
  if (route.name === "shopDetail" && route.productId) {
    return <ProductDetailPage productId={route.productId} />;
  }
  if (
    route.name === "eventDetail" &&
    (route.eventIndex !== undefined || route.eventId)
  ) {
    return (
      <EventDetailsPage eventIndex={route.eventIndex} eventId={route.eventId} />
    );
  }
  if (
    route.name === "eventRegistration" &&
    (route.eventIndex !== undefined || route.eventId)
  ) {
    return (
      <EventRegistrationPage
        eventIndex={route.eventIndex}
        eventId={route.eventId}
      />
    );
  }
  if (route.name === "paymentSuccess") return <PaymentSuccessPage />;
  if (route.name === "login") return <LoginPage />;
  if (route.name === "register") return <RegisterPage />;
  if (route.name === "confirmEmail") return <ConfirmEmailPage />;
  if (route.name === "resetPassword") {
    return <ResetPasswordPage token={route.token} />;
  }
  if (route.name === "profileUser") return <UserProfilePage />;
  if (route.name === "profileAdmin") return <AdminPage />;
  if (route.name === "admin") return <AdminPage />;
  if (route.name === "adminLeagues") return <AdminPage leaguesRouteMode />;
  if (route.name === "adminTournaments") {
    return <AdminPage historyTypeFilterFromRoute="tournament" />;
  }
  if (route.name === "adminCreateChallenge") {
    return <AdminCreateChallengePage mode="challenge" />;
  }
  if (route.name === "adminCreateTournament") {
    return <AdminCreateChallengePage mode="tournament" />;
  }
  if (route.name === "adminChallengeEdit" && route.challengeId) {
    return (
      <AdminChallengePage
        challengeId={route.challengeId}
        challengeRouteMode="edit"
        challengeName={route.challengeName}
        challengeStatus={route.challengeStatus}
        challengeType={route.challengeType}
        challengeParticipantsCount={route.challengeParticipantsCount}
        challengeScheduledAt={route.challengeScheduledAt}
      />
    );
  }
  if (route.name === "adminChallengeResults" && route.challengeId) {
    return (
      <AdminChallengePage
        challengeId={route.challengeId}
        challengeRouteMode="results"
        challengeName={route.challengeName}
        challengeStatus={route.challengeStatus}
        challengeType={route.challengeType}
        challengeParticipantsCount={route.challengeParticipantsCount}
        challengeScheduledAt={route.challengeScheduledAt}
      />
    );
  }
  if (route.name === "privacyPolicy") return <PrivacyPolicyPage />;
  if (route.name === "termsOfUse") return <TermsOfUsePage />;
  return <HomePage />;
}

function normalizeHashNavigationFromSharePath() {
  if (!window.location.hash || !window.location.pathname.startsWith("/s/")) return;
  window.history.replaceState(
    window.history.state,
    "",
    `/${window.location.hash}`,
  );
}

function normalizeSharePathNavigation() {
  if (window.location.hash) {
    normalizeHashNavigationFromSharePath();
    return;
  }

  const hashRoute = getHashRouteFromSharePath(
    window.location.pathname,
    window.location.search,
  );
  if (!hashRoute) return;

  window.history.replaceState(window.history.state, "", `/${hashRoute}`);
}

function getCurrentRouteSource() {
  normalizeSharePathNavigation();
  return window.location.hash || `${window.location.pathname}${window.location.search}`;
}

export default function AppRouter() {
  const [route, setRoute] = useState<AppRoute>(() =>
    getRouteFromHash(getCurrentRouteSource())
  );

  useEffect(() => {
    document.body.setAttribute("data-page", route.name);
    return () => {
      document.body.removeAttribute("data-page");
    };
  }, [route.name]);

  useEffect(() => {
    const handleLocationChange = () => {
      normalizeHashNavigationFromSharePath();
      setRoute(getRouteFromHash(getCurrentRouteSource()));
    };

    window.addEventListener("hashchange", handleLocationChange);
    window.addEventListener("popstate", handleLocationChange);
    return () => {
      window.removeEventListener("hashchange", handleLocationChange);
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, []);

  return resolvePage(route);
}
